import { useEffect, useState } from "react";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [cooldown, setCooldown] = useState(0);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!cooldown) return;
    const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Confirmation link sent to ${user.email}`);
      setCooldown(60);
    } catch (err) {
      toast.error(errText(err, "Couldn't send the email"));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="verify-banner" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        <MailCheck className="w-4 h-4 shrink-0" />
        <span>Confirm your email — we sent a link to <strong>{user.email}</strong>. Didn't get it?</span>
        <button type="button" data-testid="verify-resend" disabled={sending || cooldown > 0} onClick={resend}
          className="font-medium underline underline-offset-4 disabled:no-underline disabled:opacity-70">
          {cooldown ? `Sent · resend in ${cooldown}s` : sending ? "Sending…" : "Resend link"}
        </button>
      </div>
    </div>
  );
}
